(function () {
  'use strict';
  var endpoint = 'https://a.klaviyo.com/client/subscriptions?company_id=SdGjyt';
  function payload(email) {
    return {data: {type: 'subscription', attributes: {
      custom_source: 'Website newsletter signup v1 - 2026-10-04',
      profile: {data: {type: 'profile', attributes: {
        email: email.trim().toLowerCase(),
        subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
      }}}
    }, relationships: {list: {data: {type: 'list', id: 'Yg7EZm'}}}}};
  }
  async function subscribe(email, signal) {
    var response = await fetch(endpoint, {
      method: 'POST', credentials: 'omit', signal: signal,
      headers: {'Content-Type': 'application/vnd.api+json', revision: '2026-07-15'},
      body: JSON.stringify(payload(email))
    });
    if (response.status !== 202) throw new Error(response.status === 429 ? 'limited' : 'failed');
  }
  function init() {
    document.querySelectorAll('[data-newsletter-signup]').forEach(function (root) {
      if (root.dataset.wired) return;
      root.dataset.wired = 'true';
      var form = root.querySelector('form'), fieldset = form.querySelector('fieldset');
      var input = form.elements.email, button = form.querySelector('[type="submit"]');
      var error = root.querySelector('[data-newsletter-error]');
      var success = root.querySelector('[data-newsletter-success]');
      var sending = false;
      fieldset.disabled = false;
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (sending || !form.reportValidity()) return;
        if (form.elements.website.value) return;
        sending = true; button.disabled = true; error.hidden = true;
        var controller = new AbortController();
        var timer = setTimeout(function () {controller.abort();}, 15000);
        try {
          await subscribe(input.value, controller.signal);
          form.hidden = true; success.hidden = false; success.focus();
        } catch (failure) {
          error.textContent = failure.message === 'limited'
            ? 'Please wait a minute, then try again.'
            : 'We could not save your signup. Please try again.';
          error.hidden = false; error.focus();
        } finally {
          clearTimeout(timer); sending = false; button.disabled = false;
        }
      });
    });
  }
  window.OwlNewsletterSignup = {payload: payload, subscribe: subscribe, init: init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
